import { jsx as _jsx } from "react/jsx-runtime";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
;
import ProgressSteps from '@/Jetstream/ProgressSteps';
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}
export default function Progress(_a) {
    var step = _a.step, team = _a.team, branch = _a.branch, certificate = _a.certificate, onChange = _a.onChange;
    var route = useRoute(Ziggy);
    var steps = [
        {
            name: 'Client details',
            description: 'Who is the owner of these pets?',
            href: certificate.client ? route('team.branch.certificate.client-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null
        },
        {
            name: 'Vet details',
            description: 'Which vet will be stamping and signing this certificate?',
            href: certificate.client ? route('team.branch.certificate.vet-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null,
        },
        {
            name: 'Travel details',
            description: 'Where and when will the pets be travelling?',
            href: certificate.client ? route('team.branch.certificate.travel-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null
        },
        {
            name: 'Pet details',
            description: 'Which pets will be travelling?',
            href: certificate.client ? route('team.branch.certificate.pet-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null
        },
        {
            name: 'Health details',
            description: 'What vaccines and treatments are required?',
            href: certificate.client ? route('team.branch.certificate.vaccination-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null
        },
        {
            name: 'Supporting documents',
            description: 'Upload proof of identity and vaccination for all travelling pets.',
            href: certificate.client ? route('team.branch.certificate.document-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null
        },
        {
            name: 'Generate',
            description: 'Review summary and generate the AHC for download.',
            href: certificate.client ? route('team.branch.certificate.generate-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : "",
            status: null
        },
    ];
    for (var i = 0; i < steps.length; i++) {
        var _step = steps[i];
        if (i === step) {
            _step.status = 'current';
        }
        if (i > step) {
            _step.status = 'upcoming';
        }
        if (i < step) {
            _step.status = 'complete';
        }
        if (i > 0 && !certificate.client) {
            _step.status = 'disabled';
        }
    }
    return (_jsx(ProgressSteps, { step: step, team: team, branch: branch, certificate: certificate, onChange: onChange, steps: steps }));
}
